import React, { useContext, useEffect, useRef, useState } from 'react';
import { navigate } from '@reach/router';

import { Alert } from '@material-ui/lab';
import NotInterestedIcon from '@material-ui/icons/NotInterested';

import Spacer from '../../../app/common/ui/Spacer';
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FireDataContext from '../../../services/firebase/FireDataContext';
import AuthContext from '../../../services/firebase/AuthContext';
import { timestamp } from '../../../app/data/validate';
import MemberMiniMenu from '../menus/MemberMiniMenu';

const DeclineReferralContent = ({ onSubmit }) => {
    const defaultReason = `Thank you for referring this client.  Unfortunately the intermediary you selected is unavailable on this occasion.\nIf you made only one request to quote, you may find that requests to other intermediaries will be more successful. \nAlternatively you may find an independent intermediary at Intermediaries for Justice https://www.intermediaries-for-justice.org
    \nTIC is striving to match skilled intermediaries for as many clients as possible, our membership is constantly growing and we do hope we can assist you in the future. 
    \nBest wishes from The Intermediary Cooperative`;
    const reasonRef = useRef(defaultReason);

    return (
        <div>
            <Alert severity="info" variant="outlined">We (will be) required to provide HMCTS with a reason why we declined to quote. Have at it ...</Alert>
            <Spacer />
            <TextField
                inputRef={reasonRef}
                defaultValue={defaultReason}
                disabled={!Boolean(reasonRef.current.value)}
                helperText="You can edit this text as required"
                variant="outlined"
                multiline
                fullWidth
                rows={10}
                autoFocus
            />
            <Spacer />
            <Button
                disabled={!Boolean(reasonRef.current?.value)}
                onClick={() => onSubmit({ reason: reasonRef.current.value })}
                variant="contained"
                color="secondary"
                startIcon={<NotInterestedIcon />}
            >
                Decline this referral
            </Button>
        </div>
    );
}

const DeclineReferralPage = ({ requestId }) => {
    const db = useContext(FireDataContext);
    const { currentUser: { uid } } = useContext(AuthContext);
    
    const [digest, setDigest] = useState();

    useEffect(() => {
        (async () => {
            const request = await db.get({ path: `intermediaries/${uid}/referrals/${requestId}` });

            if (!request) {
                return navigate("/");
            }

            const referral = await db.get({ path: request.referralPath });
            const referrer = await db.get({ path: `users/${referral.uid}` });
            const intermediary = await db.get({ path: `users/${uid}` });
            const courtCase = await db.get({ path: `organizations/${referral.organizationId}/cases/${referral.courtCaseId}` });

            console.log('digest', { request, referral, referrer, intermediary, courtCase })
            setDigest({ request, referral, referrer, intermediary, courtCase });
        })();

    }, [db, uid, requestId])


    const handleSubmit = ({ reason }) => {
        db.insert({
            path: `organizations/${digest.referral.organizationId}/quotes`,
            payload: {
                referral: digest.referral,
                request: digest.request,
                courtCase: digest.courtCase,
                declined: {
                    reason,
                    intermediary: digest.intermediary.name,
                    ts: timestamp(),
                    uid,
                },
                status: 'declined',
            }
        })
            .then(result => {
                Promise.all([
                    db.update({
                        path: `intermediaries/${uid}/referrals/${requestId}`,
                        payload: {
                            status: 'declined',
                            declined: {
                                ts: timestamp(),
                                reason,
                                intermediary: digest.intermediary.name
                            },
                        }
                    }),
                    db.update({
                        path: digest.request.referralPath,
                        payload: {
                            quotes: [...(digest.referral.quotes || []), { quoteId: result.id, intermediary: digest.intermediary.name, status: 'declined' }],
                        }
                    }),
                ])
                    .then(() => {
                        db.insert({
                            path: 'mail',
                            payload: {
                                to: [digest.referrer.email],
                                message: {
                                    subject: `${digest.intermediary.name} was unable to provide a quote for referral ${digest.referral.bookingReference}`,
                                    html: `<div>${reason}</div>`,
                                    text: reason
                                }
                            }
                        })
                            .then(() => navigate("/casework/referrals"))
                            .catch(error => console.log(error,));

                    })
                    .catch(error => console.log(error))
            })
            .catch(error => console.log(error))
    }

    return (
        <MemberMiniMenu>
            <DeclineReferralContent onSubmit={handleSubmit} />
        </MemberMiniMenu>
    );
};

export default DeclineReferralPage;